import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a8245bb8&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=a8245bb8&prod&scoped=true&lang=css&"
import style1 from "./index.vue?vue&type=style&index=1&id=a8245bb8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8245bb8",
  null
  
)

export default component.exports